export default class Cookies {
   constructor() {
      this.container = document.querySelector('[data-cookies]')
      this.init()
   }

   init() {
      if (this.container) {
         this.cookiesHandling()
      }
   }

   cookiesHandling() {
      const cookies = localStorage.getItem('checkCookies')
      const closeBtn = document.querySelector('[data-cookies-close]')
   
      if (!cookies) {
         setTimeout(() => this.container.classList.add('is-cookies'), 600) 

         closeBtn.addEventListener('click', () => {
            localStorage.setItem('checkCookies', true)
            this.container.classList.add('is-accepted')
            this.container.classList.remove('is-cookies')
         })
      }
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/cookies.js
// module id = 9
// module chunks = 0